import Ajax from "Utils/ajax";
export const getAllStaffByHRorManager = (data) => Ajax.post('hr/getAllStaffByHRorManager',data);
export const addODException = (data) => Ajax.post('hr/addODException',data); 
export const onDutyExceptionList = (data) => Ajax.post('hr/onDutyExceptionList',data); 
export const getODExceptionById = (data) => Ajax.post('hr/getODExceptionById',data); 